import angular from 'angular';
import LiabilityDates from './liabilityDates';

export default angular
  .module('components.liabilityDates', [])
  .component('liabilityDates', LiabilityDates).name;
